<script setup lang="ts">
import type { PlayerUpgrade } from '@/types/shared/player-config'
import { usePlayer } from '@/composables/game/player'

defineProps<{ upgrades: PlayerUpgrade[] }>()
defineEmits<{
  (e: 'upgrade', upgradeId: string, price: number): void
}>()

const { player } = usePlayer()
</script>

<template>
  <div style="border: white solid thin">
    <div
      v-for="upgrade in upgrades"
      :key="upgrade.id"
      style="border: green solid thin"
    >
      <img
        width="50"
        height="50"
        :src="upgrade.imageUrl"
      > <br>
      Name: {{ upgrade.name }} <br>
      Level: {{ upgrade.level }} <br>
      Profit: {{ upgrade.profit }} <br>
      Price: {{ upgrade.price }} <br>
      Profit gain on upgrade: {{ upgrade.profitDelta }} <br>
      <button
        :disabled="upgrade.price > player.coins"
        @click="$emit('upgrade', upgrade.id, upgrade.price)"
      >
        Buy
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>
